import { ExpertChipExpression, GroupChipExpression, SimpleChipExpression } from '../data/common.data.types';

export abstract class StrictSqlWhereParserService {
  public abstract isExpressionValid(expression: string): boolean;

  public abstract parseIntoTokens(expression: string): ExpertChipExpression[];

  public abstract toExpression(chips: (SimpleChipExpression | GroupChipExpression)[]): string;

  public abstract removePlaceholders(chips: (SimpleChipExpression | GroupChipExpression)[]): (SimpleChipExpression | GroupChipExpression)[];
}
